export const skillCategories = [
  {
    id: 1,
    name: "Frontend Development",
    blurb:
      "Building responsive, accessible interfaces that translate design into polished web experiences.",
    tags: ["JavaScript", "HTML", "CSS", "React", "Responsive Design"],
    // Tags marked true render highlighted (green border)
    Languages: ["JavaScript", "HTML", "CSS"],
    Frameworks: ["React"],
    Methodologies: ["Responsive Design"],
  },
  {
    id: 2,
    name: "Backend Development",
    blurb:
      "Designing and maintaining server-side systems, APIs, and databases that scale reliably.",
    tags: [
      "Python",
      "Java",
      "SQL",
      "API Design",
      "Database Management",
      "Spring Boot",
      "PostgreSQL",
    ],
    Languages: ["Python", "Java", "SQL"],
    Frameworks: ["Spring Boot", "PostgreSQL"],
    Methodologies: ["API Design", "Database Management"],
  },
  {
    id: 3,
    name: "Game Development",
    blurb:
      "Building games in Unity and Godot — from core gameplay systems to asset pipelines.",
    tags: ["Unity", "C#", "Godot", "Gameplay Design", "Physics Systems"],
    Languages: ["C#"],
    Frameworks: ["Unity", "Godot"],
    Methodologies: ["Gameplay Design", "Physics Systems"],
  },
  {
    id: 4,
    name: "Software Development",
    blurb:
      "Writing clean, maintainable code across multiple platforms using modern practices.",
    tags: ["C", "C++", "C#", "OOP", "Agile", "Design Patterns"],
    Languages: ["C", "C++", "C#"],
    Frameworks: ["OOP", "Agile"],
    Methodologies: ["Design Patterns"],
  },
];

export const tools = [
  "Visual Studio",
  "VS Code",
  "Eclipse",
  "Unity",
  "Godot",
  "Blender",
  "Adobe Premiere",
  "Adobe Photoshop",
  "Microsoft Office",
  "Git",
  "GitLab",
  "GitHub",
  "Jira",
  "Postman",
  "Docker",
];
